import { render, staticRenderFns } from "./ItemLicenseLayout.vue?vue&type=template&id=4eb98256&scoped=true"
import script from "./ItemLicenseLayout.vue?vue&type=script&lang=js"
export * from "./ItemLicenseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb98256",
  null
  
)

export default component.exports